import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import { installSessionClient } from "./api/apiClient";

import "./index.css";

import App from "./App";

import { ThemeProvider as MTThemeProvider } from "@material-tailwind/react";
import { ThemeProvider } from "./ThemeContext";
import { AuthProvider } from "./AuthContext";
import { MessageProvider } from "./MessageContext";
import { HelmetProvider } from "react-helmet-async";

import {
    PublicClientApplication,
    EventType
} from "@azure/msal-browser";

import {
    MsalProvider
} from "@azure/msal-react";

import { msalConfig } from "./authConfig";
installSessionClient(axios, window, process.env.REACT_APP_API_URL || '');

const msalInstance =
    new PublicClientApplication(msalConfig);

async function initializeApp() {

    try {

        console.log("Initializing MSAL...");

        await msalInstance.initialize();

        console.log("MSAL Initialized");

        msalInstance.addEventCallback((event) => {

            console.group("MSAL EVENT");

            console.log("Type :", event.eventType);

            console.log(event);

            if (
                event.eventType === EventType.LOGIN_SUCCESS &&
                event.payload
            ) {

                msalInstance.setActiveAccount(
                    event.payload.account
                );

                console.log(
                    "Active Account",
                    event.payload.account
                );
            }

            console.groupEnd();

        });

        const root =
            ReactDOM.createRoot(
                document.getElementById("root")
            );

        root.render(

            <React.StrictMode>

                <MsalProvider instance={msalInstance}>

                    <AuthProvider>

                        <MessageProvider>

                            <MTThemeProvider>

                                <ThemeProvider>

                                    <HelmetProvider>

                                        <App />

                                    </HelmetProvider>

                                </ThemeProvider>

                            </MTThemeProvider>

                        </MessageProvider>

                    </AuthProvider>

                </MsalProvider>

            </React.StrictMode>

        );

    }
    catch (error) {

        console.group("MSAL INITIALIZATION FAILED");

        console.error(error);

        console.groupEnd();

    }

}

initializeApp();
